import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  FormControl,
  Input,
  useToast,
  Box,
} from "@chakra-ui/react";
import axios from "axios";
import { useState } from "react";
import { ChatState } from "../../context/chatProvider";
import UserBadgeItem from "../userAvatar/UserBadgeItem";
import UserListItem from "../userAvatar/UserListItem";

import  EnvRoute   from '../../middleware/envRoute';

const ENDPOINT = EnvRoute('prod'); 


const GroupChatModal = ({children}) => {
   const { isOpen, onOpen, onClose } = useDisclosure();
  const [groupChatName, setGroupChatName] = useState();
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [search, setSearch] = useState([]);
  const [searchResult, setSearchResult] = useState([]);
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const { user, chats, setChats } = ChatState();

  const handleGroup = (userToAdd) => {
    if (selectedUsers.includes(userToAdd)) {
      toast({
        title: "User already added",
        status: "warning",
        duration: 5000,
        isClosable: true,
        position: "top",
      });
      return;
    }

    setSelectedUsers([...selectedUsers, userToAdd]);
  };

  const handleSearch = async (query) => {
    setSearch(query);
    if (!query) {
      return;
    }

    try {
      setLoading(true);
      const config = {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      };
      const data  = await axios.get(`${ENDPOINT}/api/user?search=${search}`, config);
      console.log(data);
      setLoading(false);
      setSearchResult([...data.data]);
      // const { data } = await axios.get(`${ENDPOINT}/api/user?search=${search}`, config);
      // console.log(data);
      // setLoading(false);
      // setSearchResult(data);
    } catch (error) {
      toast({
        title: "Error Occured!",
        description: "Failed to Load the Search Results",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
    }
  };

  const handleDelete = (delUser) => {
    setSelectedUsers(selectedUsers.filter((sel) => sel._id !== delUser._id));
  };

  const handleSubmit = async () => {
    if (!groupChatName || !selectedUsers) {
      toast({
        title: "Please fill all the feilds",
        status: "warning",
        duration: 5000,
        isClosable: true,
        position: "top",
      });
      return;
    }

    try {
      const config = {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      };
      const { data}  = await axios.post(
        `${ENDPOINT}/api/chat/group`,
        {
          name: groupChatName,
          users: JSON.stringify(selectedUsers.map((u) => u._id)),
        },
        config
      );
      setChats([data, ...chats]);
      onClose();
      toast({
        title: "New Group Chat Created!",
        status: "success",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
    } catch (error) {
      toast({
        title: "Failed to Create the Chat!",
        description: error.response.data,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
    }
  };
  return (
 <>
      <span onClick={onOpen}>{children}</span>

      <Modal size="md" onClose={onClose} isOpen={isOpen} isCentered>
        <ModalOverlay />
        <ModalContent
           backgroundImage={"url('./assets/BodyBG.png')"}
        backgroundSize={"cover"}
        boxShadow={'bxshd.inset_blk'}
          borderRadius={"10px 10px 10px 10px"}
        >
          <ModalHeader
            fontSize="35px"
            fontFamily="GIlroy"
            display="flex"
            justifyContent="center"
            //  bg={'white'}
            borderRadius={"10px 10px 0 0"}
            color={'#868686'}
            background={"url('./assets/BodyBG2.png')"}
            backgroundSize={'cover'}
            boxShadow={'bxshd.inset_blk'}
          >
            Create Group Chat
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody display="flex" flexDir="column" alignItems="center">
             <Box
        display="flex"
        flexDir="column"
        p={3}
        // bg="rgba(250,250,250,0.2)"  
        bg="rgba(250,250,250,0.9)"  
        backgroundImage={"url('./assets/BodyBG2.png')"}
        // bg="#F8F8F8"  
        w="100%"
        h="100%"
        borderRadius="10px 0 10px 10px"
        overflowY="hidden"
        // backgroundImage={"url('./assets/BodyBG.png')"}
        // backgroundColor={"bgs.accntBx"}
        boxShadow={"bxshd.inset_blk"}
         backdropFilter={"blur(2px)"} 
         justifyContent={'center'}
         textAlign={'center'}
      >
            <FormControl>
              <Input
                placeholder="Chat Name"
                mb={3}
                onChange={(e) => setGroupChatName(e.target.value)}
                 backdropFilter={"blur(4px)"}
                 border = {`1px solid #868686`}
                _placeholder={{ opacity: 0.9, color: '#868686' }}
                
              />
            </FormControl>
            <FormControl>
              <Input
                placeholder="Add Users eg: Jon, Bob, Jane"
                mb={1}
                onChange={(e) => handleSearch(e.target.value)}
                backdropFilter={"blur(4px)"}
                border = {`1px solid #868686`}
                _placeholder={{ opacity: 0.9, color: '#868686' }}
                
              />
            </FormControl>
            <Box w="100%" display="flex" flexWrap="wrap">
              {selectedUsers.map((u) => (
                <UserBadgeItem
                  key={u._id}
                  user={u}
                  admin={user}
                  handleFunction={() => handleDelete(u)}
                />
              ))}
            </Box>
            {loading ? (
              // <ChatLoading />
              <div>Loading...</div>
            ) : (
              searchResult
                ?.slice(0, 4)
                .map((user) => (
                  <UserListItem
                    key={user._id}
                    user={user}
                    handleFunction={() => handleGroup(user)}
                  />
                ))
            )}
          </Box>
          </ModalBody>
          <ModalFooter>
            <Button onClick={handleSubmit} colorScheme="blue">
              Create Chat
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default GroupChatModal